const incrementSessionStorageValue = (key, amount = 1) => {
  const value = getSessionStorageNumber(key, amount)
  sessionStorage.setItem(key, value + amount)
}

const getSessionStorageNumber = (key) => {
  const value = sessionStorage.getItem(key)
  if (isNaN(value)) return 0
  return Number(value)
}

const savePreviousNumberDataToDatalayer = (key, gaProperty) => {
  // Check params
  if (key === undefined) return
  if (gaProperty === undefined) return

  // Check stored value
  const value = sessionStorage.getItem(key)

  if (value === null) return
  if (isNaN(value)) return

  const numberValue = Number(value)

  // Push to datalayer
  const newDataLayerEntry = {}
  newDataLayerEntry[gaProperty] = numberValue
  window.dataLayer.push(newDataLayerEntry)

  // Log
  console.log(`${gaProperty}: ${numberValue}`)
}

const clearSessionStorage = () => {
  sessionStorage.removeItem('thumbnails.total')
  sessionStorage.removeItem('thumbnails.success')
  sessionStorage.removeItem('thumbnails.failed')
  sessionStorage.removeItem('uploading.total')
  sessionStorage.removeItem('uploading.success')
  sessionStorage.removeItem('uploading.failed')
}

const isUnexpectedReload = () => {
  if (sessionStorage.getItem('thumbnails.total') !== null) return true
  if (sessionStorage.getItem('thumbnails.success') !== null) return true
  if (sessionStorage.getItem('thumbnails.failed') !== null) return true
  if (sessionStorage.getItem('uploading.total') !== null) return true
  if (sessionStorage.getItem('uploading.success') !== null) return true
  return sessionStorage.getItem('uploading.failed') !== null
}

export {
  incrementSessionStorageValue,
  getSessionStorageNumber,
  savePreviousNumberDataToDatalayer,
  clearSessionStorage,
  isUnexpectedReload
}
